<app-wcm-table #wcmTable [api]="apiProvitool.meraki_config_templates" [filters]="localFilters" [disabledColumns]="localDisabledColumns"
               refreshSignal="meraki-config-templates-list-refresh" urlUpdateSignal="meraki-config-templates-list-url-update"
               (rowClick)="rowClick?.emit($event)" [enableRowClick]="enableRowClick"
               [disableUrlUpdate]="disableUrlUpdate" id="meraki-config-templates"
               [allowPreferences]="allowPreferences">
  <ng-template appWcmHeaderTitle text="Template de configuration Meraki" targetRouterLink="/meraki-config-templates/list"></ng-template>
  <ng-template appWcmHeaderRight>
    <button class="btn btn-default" (click)="create()"
            *ngIf="!localDisabledButtons.create">
      <i class="fas fa-plus"></i> Ajouter un template de configuration Meraki
    </button>
    <button class="btn btn-default" (click)="syncTemplate()"
            *ngIf="!localDisabledButtons.syncTemplate" [disabled]="loading">
      <i class="fas fa-sync-alt" [ngClass]="{'fa-spin': loading}"></i> Synchroniser
    </button>
  </ng-template>

  <app-wcm-col id="external_ref" field="external_ref" header="ID" class="text-center" [preventSort]="true" width="120">
    <ng-template appWcmColBody let-item="item">
      <a href="/#/meraki-config-templates/detail/{{item.id}}">
        {{ item.external_ref }}
      </a>
    </ng-template>
  </app-wcm-col>

  <app-wcm-col field="name" header="Nom" class="text-center" [preventSort]="true" [focus]="true" type="advancedText"></app-wcm-col>

  <app-wcm-col field="types" header="Types" class="text-center" [preventSort]="true" width="150"></app-wcm-col>

  <app-wcm-col field="timezone" header="Timezone" class="text-center" [preventSort]="true" width="150"></app-wcm-col>

</app-wcm-table>
